import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface State {
  email: string;
  password: string;
  clientId: number;
  appId: number;
  region: string | null;
}

interface Actions {
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setClientId: (clientId: number) => void;
  setAppId: (appId: number) => void;
  reset: () => void;
  setRegion: (region: string) => void;
}

const initialState: State = {
  email: '',
  password: '',
  clientId: 0,
  appId: 0,
  region: null,
};

export const useAuthStore = create<State & Actions>()(
  persist(
    set => ({
      ...initialState,
      setEmail: email => set(() => ({ email })),
      setPassword: password => set(() => ({ password })),
      setClientId: clientId =>
        set(() => {
          return { clientId };
        }),
      setAppId: appId => set(() => ({ appId })),
      setRegion: region => set(() => ({ region })),
      reset: () => {
        set(initialState);
      },
    }),
    {
      name: 'auth-storage',
    },
  ),
);
